import { createFileRoute, Link, useSearch } from "@tanstack/react-router";
import { AgeVerifiedAuth } from "../../components/AgeVerifiedAuth";
import { Header } from "../../components/Header";

type SignInSearch = {
    redirectTo?: string;
};

export const Route = createFileRoute("/_layout/sign-in")({
    component: SignIn,
    validateSearch: (search: Record<string, unknown>): SignInSearch => {
        return {
            redirectTo: search.redirectTo as string,
        };
    },
    head: () => ({
        meta: [
            { name: "title", content: "Sign In - StoryDoodle" },
            {
                name: "description",
                content:
                    "Sign in to StoryDoodle and continue creating interactive AI-powered stories with your drawings. Welcome back to your creative adventure!",
            },
            { name: "robots", content: "noindex, nofollow" },
            { property: "og:title", content: "Sign In - StoryDoodle" },
            {
                property: "og:description",
                content:
                    "Sign in to StoryDoodle and continue creating interactive AI-powered stories with your drawings.",
            },
            { property: "og:url", content: "https://storydoodle.app/sign-in" },
        ],
        links: [{ rel: "canonical", href: "https://storydoodle.app/sign-in" }],
    }),
});

function SignIn() {
    const search = useSearch({ from: "/_layout/sign-in" });

    // Build redirect URL - where to go after successful auth
    const redirectTo = search.redirectTo
        ? `${window.location.origin}${search.redirectTo}`
        : `${window.location.origin}/`;

    return (
        <div className="min-h-screen page-gradient flex flex-col">
            <Header variant="auth" />
            <div className="flex-1 flex items-center justify-center p-4">
                <div className="w-full max-w-md">
                    <div className="text-center mb-8">
                        <Link to="/" className="inline-block">
                            <h1 className="text-3xl font-bold text-foreground mb-2">StoryDoodle</h1>
                        </Link>
                    </div>
                    <AgeVerifiedAuth
                        view="sign_in"
                        title="Welcome Back"
                        description="Sign in to continue your drawing adventure"
                        redirectTo={redirectTo}
                    />
                    <div className="text-center mt-4">
                        <Link to="/sign-up" className="text-sm text-muted-foreground hover:text-foreground underline">
                            Don't have an account? Sign up
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
